import { createFileRoute } from "@tanstack/react-router";
import BrickPavers from "@/pages/BrickPavers";
import { buildHead } from "@/lib/seo";

const OG_IMAGE =
  "https://vibe.filesafe.space/1779750798598342338/attachments/d7bd12bd-9100-46e0-8b4e-c8e0403c6bbb.png";

export const Route = createFileRoute("/brick-pavers")({
  head: () =>
    buildHead({
      title:
        "Brick Pavers Color & Style Gallery | Precision Pavers & Pool Design",
      description:
        "Browse our full brick paver gallery—white cement mixed, white cement solid, grey cement mixed, and grey cement solid colorways for driveways, patios, and walkways across Broward County, FL. Free estimates.",
      path: "/brick-pavers",
      ogImage: OG_IMAGE,
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Service",
          serviceType: "Brick Pavers",
          provider: {
            "@type": "HomeAndConstructionBusiness",
            name: "Precision Pavers & Pool Design",
            url: "https://precisionpaverspools.com/",
          },
          areaServed: [
            { "@type": "City", name: "Fort Lauderdale" },
            { "@type": "City", name: "Coral Springs" },
            { "@type": "City", name: "Pembroke Pines" },
            { "@type": "City", name: "Weston" },
            { "@type": "City", name: "Miramar" },
            { "@type": "City", name: "Sunrise" },
            { "@type": "City", name: "Davie" },
          ],
          url: "https://precisionpaverspools.com/brick-pavers",
          description:
            "Premium brick paver installations and patterns in Broward County, FL. Free estimates.",
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Brick Pavers",
              item: "https://precisionpaverspools.com/brick-pavers",
            },
          ],
        },
      ],
    }),
  component: BrickPavers,
});
